export const Email_Regex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const importSkillsRegex = /^\/skills\/[a-f0-9]+\/importskill$/;
export const importSkillsIntoTest = /^\/[a-f0-9]+\/importskills$/;
export const skilllibraryRegex = /^\/skill-library\/(.+)$/;
export const candInvitesRegex = /^\/[a-f0-9]+\/invite$/;
export const importQuestionsRegex = /^\/[a-f0-9]+\/questions$/;
export const importQuestionsNewRegex = /^\/[a-f0-9]+\/questions\/new$/;
